import React from "react";
import { ScoredSelectionStats, SurveyReportDataSet } from '../../../../../../amorg-common';
import { Survey } from '../../../../../../amorg-common';
import { RadialPctChart } from "../../../../../../designSystem/graphs/RadialPctChart";
import { colors } from "../../../../../../designSystem/colors/color";
import { SegmentRatioBar } from "../../../../../../designSystem/graphs/SegmentRatioBar";
import { Em } from "../../../../../../designSystem/typography/Em";
import { txt } from "../../../../../../txt";
import { PageSection } from "../../../../../../designSystem/PageSection";
import { StatCard, StatCardRow } from "../../../../../../designSystem/StatCard";
import { Small } from "../../../../../../designSystem/typography/Body";
import { Flex } from "../../../../../../designSystem/compositeComponents/FlexHelpers";


type ReportSummarySectionProps = {
    survey: Survey,
    data: SurveyReportDataSet,
    excludeQuestionSummary?:boolean,
    expandable?:boolean
}
export function ReportSummarySection(props: ReportSummarySectionProps): JSX.Element 
{
    const allQuestionData = props.data.themeData.flatMap(t => t.questions);

    function format(value: number)
    {
        return parseFloat(value.toFixed(1));
    }

    const rankedQuestions = React.useMemo(() => {
        return allQuestionData
            .filter(q => q.stats instanceof ScoredSelectionStats)
            .map((v, i) => {
                return {
                    question: v.question,
                    report: v.stats,
                    score: (v.stats as ScoredSelectionStats).score.agreePlusPct,
                    questionIndex: i
                }
            })
            .sort((a, b) => b.score - a.score)
    }, [props.data]);

    const bestQuestions = rankedQuestions.slice(0, 3);
    const worstQuestions = [...rankedQuestions].reverse().slice(0, 3);

    return (
        <div>
            <PageSection headerStyleVariant="card" contentStyleVariant="card" contentPadding="0px"
                header={{
                    title: 'Resultat for hele undersøgelsen',
                    defaultCollapsed: false,
                }}>
                    <StatCardRow>
                        <StatCard header={"De mest positive spørgsmål"} noTopBorder noRightBorder noLeftBorder>
                            {bestQuestions.map((q, i) => (
                                <Flex gap={4} key={i}>
                                    <Small>{q.question.title}</Small><Em size="14px">{q.score.toFixed(1)}</Em>
                                </Flex>
                            ))}           
                        </StatCard>
                        <StatCard header={"De mindst positive spørgsmål"} noTopBorder noRightBorder>
                            {worstQuestions.map((q, i) => (
                                <Flex gap={4} key={i}>
                                    <Small>{q.question.title}</Small><Em size="14px">{q.score.toFixed(1)}</Em>
                                </Flex>
                            ))}           
                        </StatCard>
                    </StatCardRow>
                    <StatCardRow>
                        <StatCard bottomBorderRadius noTopBorder noRightBorder noLeftBorder noBottomBorder>
                            <div style={{display:'flex', gap:'20px', alignItems:'center', marginTop:'10px'}}>
                                <RadialPctChart pct={props.data.stats.score.agreePlusPct} />
                                <div style={{flexGrow:1}}>
                                    {/* <AnswerRatioVerticalGraph summaryStats={aggregatedSelections} /> */}

                                    <SegmentRatioBar legend heightPx={16}
                                        data={[
                                            { value: format(props.data.stats.score.summary.score1Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score1, legendText:txt.SurveyScore_1 },
                                            { value: format(props.data.stats.score.summary.score2Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score2, legendText:txt.SurveyScore_2 },
                                            { value: format(props.data.stats.score.summary.score3Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score3, legendText:txt.SurveyScore_3 },
                                            { value: format(props.data.stats.score.summary.score4Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score4, legendText:txt.SurveyScore_4 },
                                            { value: format(props.data.stats.score.summary.score5Count / props.data.stats.totalSelections * 100), color: colors.graphs.survey.score.score5, legendText:txt.SurveyScore_5 }
                                        ]}
                                    />

                                </div>
                                {/* <SelectionStatsGraphics stats={aggregatedSelections} /> */}
                            </div>
                        </StatCard>
                    </StatCardRow>
                
            </PageSection>
        </div>
    )
}